import React from 'react';
import {Box} from '@mui/material';
import {t} from 'ttag';
import {IInvoice} from '../../../store/apis/interfaces/invoice';
import {LabeledField} from '@invoice-system';

interface InvoiceInformationProps {
  data: IInvoice;
}

export const InvoiceInformation = ({data}: InvoiceInformationProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={1} mt={1}>
      <LabeledField
        label={t`Invoice Date` + ':'}
        value={data?.createDate || 'N/A'}
        direction={'row'}
        variant={'body2'}
        bold={false}
      />
      <LabeledField label={t`Due Date` + ':'} value={`${data?.details?.IssueDate?.slice(0, 4)}-${data?.details?.IssueDate?.slice(4, 6)}-${data?.details?.IssueDate?.slice(6, 8)}`} direction={'row'} variant={'body2'} bold={false} />
      <LabeledField label={t`PNR` + ':'} value={data?.details?.PNR} direction={'row'} variant={'body2'}/>
      <LabeledField label={t`Payment Code` + ':'} value={data?.details?.Payment?.map((item) => item?.Code).join(' ❘ ')} direction={'row'} variant={'body2'} bold={false}/>
      <LabeledField label={t`Endorsement` + ':'} value={data?.endorsment || 'N/A'} direction={'row'} variant={'body2'} bold={false}/>
      <LabeledField label={t`Total Amount` + ':'} value={`${data?.details?.Payment?.reduce((sum, item) => sum + (Number(item?.Amount) || 0), 0)?.toFixed(2)} ${data?.details?.Currency}`} direction={'row'} variant={'body2'} />
    </Box>
  );
};

export default InvoiceInformation;
